export const color_success = "#c3dece";
export const color_warning = "#ffefbf";
export const color_error = "#eebfbf";
export const color_info = "#c9cff3";
